'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { css, styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx';
import { forwardRef } from 'react';
/**
 * @todo Combine with IconButton, size=small
 */
const StyledIconButton = styled('button')(({ theme }) => css `
    flex: none;
    border: unset;
    outline: unset;
    padding: unset;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    line-height: ${theme.tokens.FuelLineHeightBase};
    height:  ${theme.tokens.FuelLineHeightBase};
    width:  ${theme.tokens.FuelLineHeightBase};

    background-color: transparent;
    color: ${theme.tokens.FuelColorGray700}; // for font icons
    fill: ${theme.tokens.FuelColorGray700}; // for svg icons

    border-radius: ${theme.tokens.FuelBorderRadiusBase};
    margin-left: ${theme.tokens.FuelSpacing4};

    &:hover {
        background-color: rgba(221, 221, 221, 0.75); // FIXME: no token yet

        .AlertCloseButton-icon {
            color: ${theme.tokens.FuelColorBlack};
            fill: ${theme.tokens.FuelColorBlack};
        }
    }

    &:focus-visible {}
`);
const StyledCloseIcon = styled(CloseIcon)(({ theme }) => css `
    cursor: pointer;
    fill: ${theme.tokens.FuelColorGray800};
    height: calc(100% - ${theme.tokens.FuelSpacing1} / 2); // compensate for material icon's padding
    width: calc(100% - ${theme.tokens.FuelSpacing1} / 2);
    transition-duration: 0ms;
`);
export const AlertCloseButton = forwardRef(({ className, ...props }, ref) => (_jsx(StyledIconButton, { className: clsx('AlertCloseButton-root', className), ref: ref, ...props, children: _jsx(StyledCloseIcon, { className: 'AlertCloseButton-icon' }) })));
AlertCloseButton.displayName = 'AlertCloseButton';
